import { FC } from 'react';

interface CategorySidebarProps {
    categories: string[];
    activeCategory: string;
    onSelectCategory: (category: string) => void;
}

const CategorySidebar: FC<CategorySidebarProps> = ({ categories, activeCategory, onSelectCategory }) => {
    return (
        <div className='w-64 flex-shrink-0 pr-8 hidden lg:block'>
            <h3 className='text-sm font-semibold text-gray-900 uppercase tracking-wider mb-4'>
                On this page
            </h3>
            <nav className='space-y-1'>
                {categories.map((category) => (
                    <button
                        key={category}
                        onClick={() => onSelectCategory(category)}
                        className={`
              group flex items-center w-full px-3 py-2 text-sm font-medium border-l-2
              ${activeCategory === category
                                ? 'border-indigo-600 text-indigo-600'
                                : 'border-transparent text-gray-500 hover:text-gray-900 hover:border-gray-300'
                            }
            `}
                    >
                        {category}
                    </button>
                ))}
            </nav>
        </div>
    );
};

export default CategorySidebar;
